import { client } from '@/shared/api/generated/api/client.gen';

type GetCityTagSeoPath = {
  citySlug: string;
  tagSlug: string;
};

/**
 * Ищет TagCity по городу и slug. 404 = рубрики в городе нет.
 * SEO v2 (`/api/seo/v2/citytag/`) для этого не подходит: при отсутствии источника отдаёт пустой 200.
 */
export function getCityTagSeo(options: { path: GetCityTagSeoPath; signal?: AbortSignal }) {
  return client.get({
    url: '/api/web/v1/cities/{citySlug}/seo/{tagSlug}/',
    ...options,
  });
}
